export default __webpack_public_path__ + "static/media/caracteristicas.7e3caa41.png";